module.exports = __webpack_public_path__ + "static/img/aboutUsb.2714def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUsb.png
// module id = LPLD
// module chunks = 1